import { render, staticRenderFns } from "./modifyCommissionModal.vue?vue&type=template&id=1a6fa98f&scoped=true"
import script from "./modifyCommissionModal.vue?vue&type=script&lang=js"
export * from "./modifyCommissionModal.vue?vue&type=script&lang=js"
import style0 from "./modifyCommissionModal.vue?vue&type=style&index=0&id=1a6fa98f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6fa98f",
  null
  
)

export default component.exports